import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import {
  Landmark, Zap, Cpu, Globe, ShieldCheck, Coins, Radio, TrainFront,
  Sprout, Factory, HeartPulse, GraduationCap, Droplets, Mountain,
} from "lucide-react";
import { useLang } from "@/i18n";
import { api } from "@/api";
import { SectionHeading } from "@/components/Reveal";

export const SECTOR_ICONS = {
  Landmark, Zap, Cpu, Globe, ShieldCheck, Coins, Radio, TrainFront,
  Sprout, Factory, HeartPulse, GraduationCap, Droplets, Mountain,
};

export default function Sectors() {
  const { lang, t } = useLang();
  const [sectors, setSectors] = useState([]);

  useEffect(() => {
    api.get("/sectors").then((r) => setSectors(r.data)).catch(() => {});
  }, []);

  return (
    <section id="sectors" className="py-24 lg:py-32 bg-obsidian-surface" data-testid="sectors-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading overline={t.sectors.overline} title={t.sectors.title} text={t.sectors.text} testid="sectors-title" />
        <div className="mt-16 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-px bg-slate-800/40 border hairline" data-testid="sectors-grid">
          {sectors.map((s, i) => {
            const Icon = SECTOR_ICONS[s.icon] || Globe;
            const wide = i % 7 === 0;
            return (
              <motion.div
                key={s.id}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.55, delay: (i % 4) * 0.08, ease: [0.16, 1, 0.3, 1] }}
                data-testid={`sector-card-${s.key}`}
                className={`group relative bg-obsidian-surface hover:bg-obsidian-card p-6 lg:p-8 transition-colors duration-500 cursor-default ${wide ? "md:col-span-2" : ""}`}
              >
                <Icon size={22} strokeWidth={1.4} className="text-gold/80 group-hover:text-gold group-hover:scale-110 transition-[color,transform] duration-500" />
                <h3 className="mt-5 text-sm sm:text-[15px] font-medium text-slate-200 group-hover:text-gold-light transition-colors duration-300 leading-snug">
                  {lang === "fr" ? s.name_fr : s.name_en}
                </h3>
                <span className="absolute top-6 right-6 text-[10px] font-mono text-slate-400 group-hover:text-gold/70 transition-colors duration-300">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="absolute bottom-0 left-0 h-[2px] w-0 bg-gold group-hover:w-full transition-[width] duration-700" />
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
